import { render, staticRenderFns } from "./MaterialHomeScreenConfig.vue?vue&type=template&id=46dd2e60&"
import script from "./MaterialHomeScreenConfig.vue?vue&type=script&lang=js&"
export * from "./MaterialHomeScreenConfig.vue?vue&type=script&lang=js&"
import style0 from "./MaterialHomeScreenConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports